export enum UnlockChoiceEntryPoint {
    PRICE = "price",
    FLOOR_PLAN = "floor_plan",
    PRICE_HISTORY = "price_history",
    VENDOR_REPORT = "vendor_report",
    CONSTRUCTION_PHOTOS = "construction_photos",
    FAQ = "faq",
    LEAD = "lead"
}

export type UnlockChoiceOrigin = "gate" | "cta";
export enum UnlockChoiceEntryPoint {
    PRICE = "price",
    FLOOR_PLAN = "floor_plan",
    PRICE_HISTORY = "price_history",
    VENDOR_REPORT = "vendor_report",
    CONSTRUCTION_PHOTOS = "construction_photos",
    FAQ = "faq",
    LEAD = "lead"
}

export type UnlockChoiceOrigin = "gate" | "cta";
